import clsx from "clsx";

export default function EventPicker({ events, value, onChange }) {
  return (
    <div className="grid gap-3">
      {events.map((e) => (
        <button
          key={e.id}
          onClick={() => onChange(e.id)}
          data-testid={`event-option-${e.id}`}
          className={clsx(
            "text-left rounded-2xl p-5 border transition-all",
            value === e.id
              ? "border-coral bg-coral/5"
              : "border-[#EFE7D2] hover:border-coral/50"
          )}
        >
          <p className="text-[10px] font-bold tracking-widest uppercase text-coral">
            {e.weekday} · {e.month_short} {e.day} · {e.time_range}
          </p>
          <p className="font-serif text-xl mt-1">{e.concept_name}</p>
          <p className="text-grey text-sm mt-1">{e.location}</p>
        </button>
      ))}
    </div>
  );
}
